var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"popup-result"},[_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('最近5次运行时间')))]),_c('ul',{staticClass:"popup-result-scroll",staticStyle:{"padding":"20px"}},[(_vm.isShow)?_vm._l((_vm.resultList),function(item){return _c('li',{key:item},[_vm._v(_vm._s(item))])}):_c('li',[_vm._v(_vm._s(_vm.$t('计算结果中...')))])],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }